export function XML_Cmd3(theCmd, param1, param2, param3, xmlCanvas) {
  var s = xmlCanvas.GetStream();
  xmlCanvas.OutputElementQuad("cm", theCmd, param1, param2, param3, s);
}
